import { css } from '@emotion/react';
import { Typography, Stack } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { Box } from '@mui/system';
import { ClubLogo, Image } from '@scorenco/components';
import { Types } from '@scorenco/core';

const style = {
  root: (theme: Theme) => css`
    position: absolute;
    top: -5rem;
    left: 0;
    right: 0;
    height: calc(100vh - 0.5rem);
    background-color: ${theme.vars.palette.secondary.main};
    color: ${theme.vars.palette.secondary.contrastText};
    display: flex;
    align-items: center;
    justify-content: center;

    .background-image {
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.25;
    }
  `,
};

export const ClubTitle = ({
  clubHouse,
}: {
  clubHouse: Types.Clubhouse_Club_House;
}) => {
  return (
    <Box css={style.root}>
      {clubHouse.banner && (
        <Image src={clubHouse.banner} className="background-image" />
      )}
      <Stack gap={2} sx={{ zIndex: 10 }}>
        <ClubLogo
          logo={clubHouse.club?.logo}
          height={256}
          width={256}
          style={{ height: '20rem' }}
        />
        <Typography align="center" variant="h1">
          {clubHouse.club?.name}
        </Typography>
      </Stack>
    </Box>
  );
};
